export default "__VITE_ASSET__DG2clUbn__"